export const GET_LOG = 'GAME_LOG/GET_LOG';
export const SET_LOG = 'GAME_LOG/SET_LOG';
/** The log with the board after each move, for replaying the game (fetched only when a replay opens). */
export const GET_REPLAY = 'GAME_LOG/GET_REPLAY';
export const SET_REPLAY = 'GAME_LOG/SET_REPLAY';
